// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"mexico_Tooltip__1v40e","Indicador":"mexico_Indicador__1XwN0","FadeIn":"mexico_FadeIn__3DzNI","fadeIn":"mexico_fadeIn__24OLC"};